<script setup>
const props = defineProps({
    automationId: {
        type: Number,
        required: true,
    },

})
</script>
<template>
    <communications-newsletter-composer
        :automation-id="automationId"
    >

    </communications-newsletter-composer>
</template>
